<template lang="pug">
.event.grow.container.is-fluid.p-1
    .columns.is-vcentered
        .column.is-narrow.date-font
            p.is-size-2.has-text-weight-bold.no-vspace 02
            p.is-size-6.has-text-weight-bold.is-uppercase May
    .columns.is-vcentered
        .column.left-align.event-font
            p.is-size-5.has-text-weight-medium Contract Meeting 2020
            p.is-size-6.has-text-weight-light 8/30/20 @ 7 pm
</template>

<script>
export default {
  name: "Event"
};
</script>

<style lang="scss" scoped>
.event {
  background: #00b894;
  border-radius: 4px;
}

.grow {
  transition: all 0.2s ease-in-out;
}

.grow:hover {
  transform: scale(1.05);
}

.date-font {
  color: #dfe6e9;
}

.event-font {
  color: white;
}

.no-vspace {
  margin-bottom: -15px;
  margin-top: -10px;
}

.left-align {
  text-align: left;
}
</style>
